/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AuthzChallenge,
  AuthzChallenge$inboundSchema,
} from "./authzchallenge.js";

export type ListChallengesResult = {
  /**
   * The challenge events.
   */
  challenges: Array<AuthzChallenge>;
  /**
   * Total number of matching challenges for pagination.
   */
  total: number;
};

/** @internal */
export const ListChallengesResult$inboundSchema: z.ZodMiniType<
  ListChallengesResult,
  unknown
> = z.object({
  challenges: z.array(AuthzChallenge$inboundSchema),
  total: z.int(),
});

export function listChallengesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListChallengesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListChallengesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListChallengesResult' from JSON`,
  );
}
